import React from "react";

export const listNoDataRenderReasonCode = (element: React.ReactElement<HTMLDivElement>, message:string) => {
    const noData = (
        <h4 style={{ fontSize: "1em" }}>
            {message}
        </h4>
    );
    return React.cloneElement(element, { ...element.props }, noData);
};